<template>
	<div>
		<div class="col-12 mt-3 pl-3 none_gauge" v-if="!this.is_pay">


				<iframe src="https://www.credit100.com/" class="w-100 h-100" ref="iframe" frameborder="0" ></iframe>


		</div>
        <div class="col-md-12 mt-3 pl-3 none_gauge" v-if="this.is_pay">
            <div class="charge_hint nano w-100 h-100">
                <div class="centre_content nano-content">
                    <div class="card text-center p-3 pb-0">
                        <div class="card-body p-0 mycard">
                            <h5 class="mt-3 mb-3">
                                <img src="../../../assets/images/silkRoadBase/member.png" class="mr-2" />
                                VIP专享
                            </h5>
                            <h4 class="f20 fn600">此内容为付费内容</h4>
                            <p class="card-text f15 text-secondary mt-3 mb-3">充值成为VIP，立享新华丝路独家服务</p>
                            <a href="/db#/accountSettings/menberCenter" class="btn btn-warning mt-3 text-white">立即开通</a>
                            <p class="mt-5 mb-5">更多VIP特权功能</p>
                            <div class="d-flex row justify-content-around m-0">
                                <div class="card col-md-4 col-12 p-0">
                                    <div class="card-body">
                                        <img src="../../../assets/images/silkRoadBase/56878730129766812.png" />
                                        <h5 class="card-title mt-3 mb-3">分析师服务</h5>
                                        <h6 class="card-subtitle mb-2 text-muted">大量专家分析师为您服务</h6>
                                    </div>
                                </div>
                                <div class="card col-md-4 col-12 p-0">
                                    <div class="card-body">
                                        <img src="../../../assets/images/silkRoadBase/41408370476170076.png" />
                                        <h5 class="card-title mt-3 mb-3">咨询服务</h5>
                                        <h6 class="card-subtitle mb-2 text-muted">大量专家分析师为您服务</h6>
                                    </div>
                                </div>
                                <div class="card col-md-4 col-12 p-0">
                                    <div class="card-body">
                                        <img src="../../../assets/images/silkRoadBase/507574572099684577.png"/>
                                        <h5 class="card-title mt-3 mb-3">海外活动服务</h5>
                                        <h6 class="card-subtitle mb-2 text-muted">大量专家分析师为您服务</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
	</div>
</template>
<script>
	export default({
		name: 'credit',
		data: function() {
			return {
                is_pay: true
			}

		},
		created: function() {
            var self = this;
            // 检查用户权限
            this.$axios.post('/api/pc/checkpagepermission', {'type':'credit'}).then(function (response) {
                if (response.data.state) {
                    if (!response.data.data.is_pay) {
                        self.is_pay = false;
                    }
                }
            })
		},
		mounted() {
			this.load();
		},
	})

</script>
